import type { AppDispatch } from "_shared/_stores/store-types";
import { individualsApi } from "marketplace/individuals/_api/individual-api";
import Individual from "marketplace/individuals/individual";

/**
 * Display names by user id, for telling the user who a new draft left out. Best effort: a person the
 * reader's directory will not name is simply missing from the map.
 *
 * Shared by a draft started from a previous proposal (#1569) and from a proposal template (#6129).
 */
export async function fetchIndividualNames(dispatch: AppDispatch, userIds: Set<string>): Promise<Map<string, string>> {
  const individuals = await dispatch(individualsApi.endpoints.getIndividualsByUserIds.initiate({ userIds: [...userIds] })).unwrap();
  return new Map(
    (Individual.fromJSONArray(individuals, { allowEmpty: true }) ?? []).flatMap((individual) => {
      const fullName = individual.fullName?.trim();
      return fullName ? [[individual.userId.value, fullName] as const] : [];
    }),
  );
}
